import { CONFIG_FETCHER_ACTIONS } from "../../actions/configFetcherActions";
import { parseResponse } from "../../helpers/helper";

const configsDataReducer = (state = {data: null, colorPallete: null}, action) => {
  switch (action.type) {
    case CONFIG_FETCHER_ACTIONS.FETCH_CONFIG_DATA_SUCCESS: {
      return {
        ...state,
        data: parseResponse(action.payload)
      };
    }
    case CONFIG_FETCHER_ACTIONS.FETCH_CONFIG_DATA_ERROR: {
      return {
        ...state,
        data: action.payload
      };
    }
    case CONFIG_FETCHER_ACTIONS.FETCH_COLOR_PALETTE_DATA_SUCCESS: {
      return {
        ...state,
        colorPallete: {
          ...state.colorPallete,
          [action.payload.paletteType]: parseResponse(action.payload.data)
        }
      };
    }
    case CONFIG_FETCHER_ACTIONS.FETCH_COLOR_PALETTE_DATA_ERROR: {
      return {
        ...state,
        data: action.payload
      };
    }
  }
  return state;
};

export default configsDataReducer;
